import { Injectable } from '@angular/core';
import { isNil } from 'ramda';

@Injectable({ providedIn: 'root' })
export class StorageService {
  constructor() {}

  public getItem(storageKey: string): string {
    return localStorage.getItem(storageKey);
  }

  public setItem(storageKey: string, value: string): void {
    if (isNil(value)) {
      throw new Error('incorrect value set');
    }

    localStorage.setItem(storageKey, value);
  }
}
